// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"e088e93996d1c8477521","655":"943e806fa61d450c8887"}[chunkId] + ".js";
};